import map_uryo from '../map/map_uryo';
/**
 * トップページ（土砂災害メッシュ）の処理
 */
export default class detail_uryo_map extends map_uryo {
    /**
     * コンストラクタ
     * @param mapPos
     * @param onUryoPointClick
     * @param isSp
     */
    constructor(mapPos, onUryoPointClick, isSp) {
        super("detail_uryo_map", mapPos, isSp);
        this._onUryoPointClick = onUryoPointClick;
        this.Map.zoomControl.remove();
        this.checkUpdateLayer();
    }
    /**
     * デフォルト地図レイヤID
     */
    getDefaultLeyerId() {
        return dosya_1kmesh_env.deteil_uinfo_map_id;
    }
    /**
     * 雨量計測地点クリック時イベント
     * @param properties
     */
    onUryoPointClick(uryoPoint) {
        if (this._onUryoPointClick) {
            this._onUryoPointClick(uryoPoint);
        }
    }
}
